import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import { getShouldShowStarterSitePageUpgradeBanner, getShouldShowFreeSitePageUpgradeBanner, getUsageLimit, getContentQuantityUsed, getShouldShowFreeBlogPostUpgradeBanner, getShouldShowFreeLandingPageUpgradeBanner // @ts-expect-error Untyped module
} from '../selectors/contentUsageSelectors'; // @ts-expect-error Untyped module

import { ContentTypes } from '../constants/base';

const ContentUsageLimitUpgradeBanner = ({
  contentType
}) => {
  const contentLimit = useSelector(getUsageLimit);
  const contentQuantityUsed = useSelector(getContentQuantityUsed);
  const shouldShowStarterSitePageUpgradeBanner = useSelector(getShouldShowStarterSitePageUpgradeBanner);
  const shouldShowFreeSitePagesRemoveBrandingBanner = useSelector(getShouldShowFreeSitePageUpgradeBanner);
  const shouldShowFreeLandingPageUpgradeBanner = useSelector(getShouldShowFreeLandingPageUpgradeBanner);
  const shouldShowFreeBlogPostUpgradeBanner = useSelector(getShouldShowFreeBlogPostUpgradeBanner);
  let upgradeKey;

  if (contentType === ContentTypes.SITE_PAGE) {
    if (shouldShowStarterSitePageUpgradeBanner) {
      upgradeKey = 'site-pages-pro-user-usage-limit';
    } else if (shouldShowFreeSitePagesRemoveBrandingBanner) {
      upgradeKey = 'site-pages-starter-user-usage-limit';
    }
  } else if (contentType === ContentTypes.LANDING_PAGE && shouldShowFreeLandingPageUpgradeBanner) {
    upgradeKey = 'landing-page-usage-limit-detail-page';
  } else if (contentType === ContentTypes.BLOG_POST && shouldShowFreeBlogPostUpgradeBanner) {
    upgradeKey = 'blog-post-cms-starter-usage-limit-detail-page';
  }

  if (!upgradeKey) return null;
  return /*#__PURE__*/_jsx(UIUpgradeBanner, {
    className: "m-x-5 m-top-3",
    limit: contentLimit,
    upgradeKey: upgradeKey,
    value: contentQuantityUsed
  });
};

export default ContentUsageLimitUpgradeBanner;